import { useSelector, useDispatch } from "react-redux";
import { saveCustomForm } from "../../stores/customForm/customFormActions";

const CustomFormSaveButton = ({ url }) => {
  const dispatch = useDispatch();
  const saveStatus = useSelector((state) => state.customForm.custom_form.save_status);

  const handleSaveCustomForm = (e) => {
    e.preventDefault();
    dispatch(saveCustomForm(url));
  };

  const renderButton = () => {
    if (saveStatus === "saving") {
      return (
        <a href="##" className="btn btn-primary">
          <i className="fa fa-spinner fa-spin"></i>
        </a>
      );
    } else if (saveStatus === "success") {
      return (
        <a href="##" className="btn btn-primary">
          <i className="fa fa-check"></i>
        </a>
      );
    } else if (saveStatus === "error") {
      return (
        <a href="##" className="btn btn-danger">
          <i className="fa fa-times"></i>
        </a>
      );
    } else {
      return (
        <a href="##" onClick={handleSaveCustomForm} className="btn btn-primary">
          Save
        </a>
      );
    }
  };

  return <span>{renderButton()}</span>;
};

export default CustomFormSaveButton;
